import { Seo } from 'src/components/seo';
import { usePageView } from 'src/hooks/use-page-view';
import { HomeHero } from 'src/sections/home/home-hero';
import { HomeServices } from 'src/sections/home/home-services';
import { HomeHowItWorks } from 'src/sections/home/home-how-it-works';
import { HomeContact } from 'src/sections/home/home-contact';
import { Box } from '@mui/material';

const Page = () => {
  usePageView();

  return (
    <>
      <Seo title="Platinx Exchange — Global Remittance & OTC Trading" />
      <Box component="main" sx={{ overflowX: 'hidden', bgcolor: '#06040F' }}>
        <HomeHero />
        <HomeServices />
        <HomeHowItWorks />
        <HomeContact />
      </Box>
    </>
  );
};

export default Page;
